/** What chat can do with one uploaded file. Mirrors shanks DescribeFileRead. */ function fileExt(filename) {
    const dot = filename.lastIndexOf('.');
    return dot >= 0 ? filename.slice(dot).toLowerCase() : '';
}
/**
 * One sentence per file: what chat can read, or why it cannot.
 * A silent "processed" for a type we cannot read is a defect.
 */ export function describeFileRead(filename, mimeType = '') {
    const name = filename.trim() || 'this file';
    const ext = fileExt(name);
    switch(ext){
        case '.txt':
        case '.md':
        case '.markdown':
        case '.json':
        case '.html':
        case '.htm':
            return {
                kind: 'text',
                filename: name,
                ext,
                message: `${name} can be read as text.`
            };
        case '.csv':
        case '.tsv':
            return {
                kind: 'table',
                filename: name,
                ext,
                message: `${name} can be read as a table.`
            };
        case '.docx':
        case '.xlsx':
        case '.pptx':
            return {
                kind: 'office',
                filename: name,
                ext,
                message: `${name} can be read (paragraphs, tables, and sheets).`
            };
        case '.pdf':
            return {
                kind: 'convert',
                filename: name,
                ext,
                message: `${name} is converted to text before it can be read.`
            };
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.tif':
        case '.tiff':
        case '.webp':
            return {
                kind: 'convert',
                filename: name,
                ext,
                message: `${name} is converted to text (image/OCR) before it can be read.`
            };
        case '.rtf':
            return {
                kind: 'richtext',
                filename: name,
                ext,
                message: `${name} can be read as plain text.`
            };
        case '.doc':
            return {
                kind: 'unsupported',
                filename: name,
                ext,
                message: `${name} is a legacy Word file and cannot be read here. Save it as .docx and upload that.`
            };
        case '.xls':
            return {
                kind: 'unsupported',
                filename: name,
                ext,
                message: `${name} is a legacy Excel file and cannot be read here. Save it as .xlsx or CSV and upload that.`
            };
        case '.ppt':
            return {
                kind: 'unsupported',
                filename: name,
                ext,
                message: `${name} is a legacy PowerPoint file and cannot be read here. Save it as .pptx and upload that.`
            };
        case '.mpp':
            return {
                kind: 'unsupported',
                filename: name,
                ext,
                message: `${name} is a Microsoft Project file and cannot be read here. Export a PDF or CSV and upload that.`
            };
        default:
            break;
    }
    if (mimeType.toLowerCase().startsWith('text/')) {
        return {
            kind: 'text',
            filename: name,
            ext,
            message: `${name} can be read as text.`
        };
    }
    if (ext === '') {
        return {
            kind: 'unsupported',
            filename: name,
            ext,
            message: `${name} has no file type, so chat cannot read it.`
        };
    }
    return {
        kind: 'unsupported',
        filename: name,
        ext,
        message: `${name} (${ext}) cannot be read here.`
    };
}
